import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { LocalizationModule } from '../../Core/Localization/localization.module';
import { MiscModule } from '../Misc/misc.module';
import { CommonBasicModule } from '../Basic/basic.module';
import { CoreDialogsModule } from '../../Core/Dialogs/dialogs.module';
import { TakeOverModule } from '../TakeOver/take-over.module';
import { CommonFormsModule } from '../Forms/forms.module';

import { BrandIdentityService } from './services/brand-identity.service';
import { BrandIdentityApiService } from '../../api/brandIdentity/brand-identity.api.service';

import { ManageBrandIdentitiesDialogComponent } from './components/ManageBrandIdentitiesDialog/manage-brand-identities-dialog.component';
import { BrandIdentityCardComponent } from './components/BrandIdentityCard/brand-identity-card.component';
import { BrandInformationComponent } from './components/BrandInformation/brand-information.component';
import { BrandLogoComponent } from './components/BrandLogo/brand-logo.component';
import { BrandColorsComponent } from './components/BrandColors/brand-colors.component';
import { BrandCompetitorsComponent } from './components/BrandCompetitors/brand-competitors.component';
import { BrandTopicsComponent } from './components/BrandTopics/brand-topics.component';
import { BrandSocialLinksComponent } from './components/BrandSocialLinks/brand-social-links.component';
import { BrandCustomInformationComponent } from './components/BrandCustomInformation/brand-custom-information.component';
import { PageBuilderModule } from '@Common/PageBuilder/page-builder.module';



@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        PageBuilderModule,
        ReactiveFormsModule,
        DragDropModule,
        LocalizationModule,
        CommonFormsModule,
        CoreDialogsModule,
        MiscModule,
        CommonBasicModule,
        TakeOverModule
    ],
    declarations: [
        ManageBrandIdentitiesDialogComponent,
        BrandIdentityCardComponent,
        BrandInformationComponent,
        BrandLogoComponent,
        BrandColorsComponent,
        BrandCompetitorsComponent,
        BrandTopicsComponent,
        BrandSocialLinksComponent,
        BrandCustomInformationComponent
    ],
    exports: [
        ManageBrandIdentitiesDialogComponent,
        BrandIdentityCardComponent,
        BrandInformationComponent,
        BrandCompetitorsComponent,
        BrandCustomInformationComponent
    ],
    providers: [
        BrandIdentityService,
        BrandIdentityApiService,
    ]
})
export class BrandIdentityModule  {}
